Ext.define('SA.model.Dataset', {
    constructor({id, name, premium, latestGeographicRelease, censusReleases, countryCode, vendorName, hasFolders}) {
        this.id = id;
        this.name = name;
        this.premium = premium;
        this.latestGeographicRelease = latestGeographicRelease;
        this.censusReleases = censusReleases;
        this.countryCode = countryCode;
        this.vendorName = vendorName;
        this._hasFolders = hasFolders;
    },

    getId() {
        return this.id;
    },

    getLatestGeographicRelease() {
        return this.latestGeographicRelease;
    },

    getName() {
        return this.name;
    },

    getVendorName() {
        return this.vendorName;
    },

    hasCountryCode(countryCode) {
        return countryCode === this.countryCode;
    },

    hasFolders() {
        return this._hasFolders;
    },

    getEditionsForCensusReleaseYear(censusReleaseYear) {
        return this.censusReleases.getEditionsForCensusReleaseYear(censusReleaseYear);
    },

    getLatestEditionForCensusReleaseYear(censusReleaseYear) {
        return this.censusReleases.getLatestEditionForCensusReleaseYear(censusReleaseYear);
    },

    hasCensusReleaseYear(censusReleaseYear) {
        return this.censusReleases.hasCensusReleaseYear(censusReleaseYear);
    },

    hasEditionInCensusRelease({edition, censusReleaseYear}) {
        return this.censusReleases.hasEditionInCensusRelease({edition, censusReleaseYear});
    },

    hasId(...ids) {
        return ids.includes(this.getId());
    },

    isACS() {
        return this.hasId(SA.DatasetIds.ACS);
    },

    isAnyScarborough() {
        return this.isScarboroughCrosstab() || this.isScarboroughNonCrosstab();
    },

    isCrosstab() {
        return this.isSimmonsCrosstab() || this.isScarboroughCrosstab();
    },

    isImport() {
        return false;
    },

    isPolygon() {
        return !this.isCrosstab();
    },

    isPremium() {
        return this.premium;
    },

    isScarboroughCrosstab() {
        return this.hasId(SA.DatasetIds.ScarboroughCrosstab);
    },

    isScarboroughNonCrosstab() {
        return this.hasId(SA.DatasetIds.ScarboroughNonCrosstab);
    },

    isSimmonsCrosstab() {
        return this.hasId(SA.DatasetIds.MRISimmonsCrosstab, SA.DatasetIds.SimmonsCrosstab);
    },

    isStandard() {
        return !this.isPremium();
    }
});